<template>
  <div>
    <div v-if="styled" class="w-full border">
      <div href="#" class="flex justify-between items-center cursor-pointer" @click.prevent="isOpen=!isOpen">
        <slot name="title">{{title}}</slot>
        <div>
          <slot name="expand">
            <span class="p-3 text-black">{{isOpen ? hideTitle: expandTitle}}</span>
          </slot>
        </div>
      </div>
      <slot name="expandable" v-if="isOpen">
        Details
      </slot>
    </div>
    <div v-else>
      <a href="#" class="flex justify-between items-center" @click.prevent="isOpen=!isOpen">
        <slot name="title">{{title}}</slot>
        <!--<div>
          <slot name="expand">
            <span>{{isOpen ? hideTitle: expandTitle}}</span>
          </slot>
        </div>-->
      </a>
      <slot name="expandable" v-if="isOpen">
        Details
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startsOpen: {
      default: false
    },
    title: String,
    expandTitle: {
      default: '\u25bc'
    },
    hideTitle: {
      default: '\u25b2'
    },
    styled: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  mounted () {
    this.isOpen = this.startsOpen
  }
}
</script>

<style>

</style>
